export default __webpack_public_path__ + "static/media/provbee.9f4feea8.png";